import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Loader2 } from 'lucide-react';
import { brandsApi } from '../../services/api';
import { CatalogueNav } from './CatalogueNav';

export const useBrand = (brandId) => {
  const [brand, setBrand] = useState(null);
  useEffect(() => {
    brandsApi.get(brandId).then((r) => setBrand(r.data)).catch(() => setBrand(false));
  }, [brandId]);
  return brand;
};

export const Spinner = () => (
  <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin text-gray-400" /></div>
);

export const CatalogueShell = ({ brandId, crumbs = [], title, intro, query, children, testId }) => {
  const brand = useBrand(brandId);
  return (
    <div className="bg-white min-h-screen" data-testid={testId}>
      <CatalogueNav brandId={brandId} brandName={brand?.name || ''} initialQuery={query} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-20">
        <nav className="flex flex-wrap items-center gap-1 text-sm text-gray-400 mb-6" data-testid="breadcrumbs">
          <Link to={`/brand/${brandId}`} className="hover:text-gray-900">{brand?.name || 'Brand'}</Link>
          {crumbs.map((c) => (
            <React.Fragment key={c.label}>
              <ChevronRight className="h-3.5 w-3.5" />
              {c.to ? <Link to={c.to} className="hover:text-gray-900">{c.label}</Link> : <span className="text-gray-700">{c.label}</span>}
            </React.Fragment>
          ))}
        </nav>
        {title && <h1 className="text-4xl sm:text-5xl font-light text-gray-900 mb-3" data-testid="page-title">{title}</h1>}
        {intro && <p className="text-gray-500 mb-10 max-w-2xl">{intro}</p>}
        {children}
      </div>
    </div>
  );
};
